import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, FlexColumn, FlexRow, ServicingSection } from 'web-ui-components/lib/global/layout';
import { Divider } from 'web-ui-components/lib/atoms/layout';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Title } from 'web-ui-components/lib/atoms/text';
import PageNavigation from '../../../sharedComponents/PageNavigation/PageNavigation';
import BacsStatusBlock from '../BacsStatusBlock/BacsStatusBlock';
import Notifications from '../../../sharedComponents/Notifications';
import { getAuthorisationMessage } from '../../../helpers/fieldHelpers';
import { ErrorValidationMessage } from '../../../sharedComponents/ErrorValidationMessage/ErrorValidationMessage';

import { paymentReviewContent } from '../../../sharedComponents/PaymentReview/PaymentReview.content';

const { noAvailableAuthorisersErrorMessage } = paymentReviewContent;

class BacsReview extends Component {
	componentDidMount() {
		this.props.handlePaymentInReview(true);
	}
	componentWillUnmount() {
		this.props.handlePaymentInReview(false);
	}

	render() {
		const {
			content,
			hasApiCallInProgress,
			bacsDetails,
			authRequired,
			deadlineMissed,
			renderDeadlineMissed,
			renderBacsSummary,
			renderBacsTable,
			handleBack,
			handleContinue,
			openAuthoriserModal,
			authorisers,
			isDefaultAuthorisers,
			userId,
			hasGroupApprovalsEnabled,
		} = this.props;

		const {
			title,
			description,
			reminder,
			continueButtonText,
			AuthorisationHeader,
			AuthorisationBodyMsg,
			viewAuthoriserButton,
			AuthorisationByUserSubTitle,
			changeAuthoriserButton,
			selectAuthoriserButton,
		} = content;

		const { authorisersGroup = [] } = bacsDetails;

		const authorisersRequired =
			authRequired && (!hasGroupApprovalsEnabled ? !authorisers.length : !authorisersGroup.length);
		const showAuthButton = !isDefaultAuthorisers;
		const authMessage = getAuthorisationMessage(authorisers, userId, AuthorisationByUserSubTitle);
		const showHasNoAvailableAuthorisersError = authRequired && !authorisersGroup.length && !isDefaultAuthorisers;
		const selectAuthoriserButtonLabel = authorisers.length ? changeAuthoriserButton : selectAuthoriserButton;
		return (
			<div>
				<Container className="u-padding-y-2" size="lg">
					<PageHeading isFlush data-test-id="bacs-review-page">
						{title}
					</PageHeading>
					<p className="u-margin-top-1">{description}</p>
					<p>{reminder}</p>
					<div className="u-margin-bottom-2">
						<Notifications />
					</div>
				</Container>
				<ServicingSection padded={false}>
					<div className="u-background-color-grey-tint-95 u-padding-4">
						<Title size="h4">{bacsDetails.paymentName}</Title>
						<Divider />
						<FlexRow>
							<FlexColumn>
								<div className="u-flex-full-height">{renderBacsSummary()}</div>
							</FlexColumn>

							{authRequired && (
								<FlexColumn>
									<BacsStatusBlock
										title={AuthorisationHeader}
										type="authorisation"
										openAuthoriserModal={openAuthoriserModal}
										bacsId={bacsDetails.bacsId}
										authoriserButtonText={hasGroupApprovalsEnabled ? viewAuthoriserButton : selectAuthoriserButtonLabel}
										showAuthoriserButton={showAuthButton && !showHasNoAvailableAuthorisersError}
									>
										{showHasNoAvailableAuthorisersError ? (
											<ErrorValidationMessage data-test-id="no-available-error-authorisers-error-message">
												{noAvailableAuthorisersErrorMessage}
											</ErrorValidationMessage>
										) : (
											<div>
												<p>{AuthorisationBodyMsg}</p>
												<p>{authMessage}</p>
											</div>
										)}
									</BacsStatusBlock>
								</FlexColumn>
							)}
						</FlexRow>
						{renderBacsTable()}
					</div>
				</ServicingSection>
				<Container className="u-padding-y-2" size="lg">
					<PageNavigation
						showLoading={hasApiCallInProgress}
						handleContinue={handleContinue}
						enableContinue={!hasApiCallInProgress && !authorisersRequired}
						showContinue
						continueButtonText={continueButtonText}
						showBack
						handleBack={handleBack}
						enableBack={!hasApiCallInProgress}
					/>
				</Container>
				{deadlineMissed && renderDeadlineMissed()}
			</div>
		);
	}
}

BacsReview.propTypes = {
	bacsDetails: PropTypes.shape({}).isRequired,
	content: PropTypes.shape({}).isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	handleContinue: PropTypes.func.isRequired,
	handleBack: PropTypes.func.isRequired,
	authRequired: PropTypes.bool.isRequired,
	deadlineMissed: PropTypes.bool,
	openAuthoriserModal: PropTypes.func,
	renderBacsTable: PropTypes.func.isRequired,
	renderBacsSummary: PropTypes.func,
	renderDeadlineMissed: PropTypes.func,
	handlePaymentInReview: PropTypes.func,
	authorisers: PropTypes.arrayOf(PropTypes.shape({})),
	isDefaultAuthorisers: PropTypes.bool,
};

BacsReview.defaultProps = {
	authorisers: [],
};

export default BacsReview;
